export const ApplicationRoutes = {
  jobs: {
    overview: '/jobs'
  },
  purchasing: {
    purchaseOrders: '/purchasing/purchase-orders'
  },
  account: {
    myProfile: '/my-profile',
    login: '/login',
    logout: '/logout',
    resetPassword: '/reset-password',
    confirmEmail: '/confirm-email',
    forgotPassword: '/forgot-password',
    requireReset: '/require-password-reset'
  },
  admin: {
    userManagement: '/admin/user-management',
    companyManagement: '/admin/company-management',
    equipmentHistoryReport: '/admin/equipment-history-report',
    equipmentHistoryReportDetail: '/admin/equipment-history-report/detail',
    hrManagement: '/admin/hr-management'
  },
  safety: {
    safetyTicketReport: '/safety/safety-ticket-report'
  },
  reporting: {
    timesheetSummary: '/legacy/reporting/timesheet-summary',
    timesheetSummaryAdmin: '/legacy/admin/timesheet-summary',
    timesheetSummaryField: '/legacy/management/timesheet-summary',
    equipmentUsageV2: '/legacy/reporting/equipment-usage-v2'
  },
  quickLinks: {
    overview: '/quick-links',
    management: '/management/quick-links'
  },
  invoicing: {
    invoiceApproval: '/legacy/accounting/invoice-approval',
    invoiceNumberReport: '/invoicing/invoice-number-report'
  },
  dev: {
    signalrTest: '/dev/signalr-test'
  },
  util: {
    onLogin: '/'
  }
};
